import {ButtonType, ButtonWidget, TabStyles, Tooltip, TooltipPosition, TooltipProps} from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { ValueConcept } from '../../../types/ValueConcept';
import { Dictionary } from 'underscore';
import { DataType } from '../../../types/DetailEnums';
import { imgPath } from '../../../../common/utilities/ImgUrl';
import {
  FieldConceptIndexingErrorCode,
  FieldConceptIndexingStatusCode
} from '../../../../ts/ServerApi/requests/GetFieldConceptIndexingStatus';
import {sectionTitleClass} from '../../../styles/DefinitionSubspaceSharedStyles';

const paddedButton: React.CSSProperties = {
  marginRight: TabStyles.Spacing.SmallSpace,
  marginLeft: TabStyles.Spacing.SmallSpace,
};

export interface ValuesSectionEditButtonsProps {
  readonly isReadonly: boolean;
  readonly isEditing: boolean;
  readonly setIsEditing: (value: boolean) => void;
  readonly dataTypes: ReadonlyArray<DataType>;
  readonly fieldConceptIndexingStatusCode: FieldConceptIndexingStatusCode;
  readonly fieldConceptIndexingErrorCode: FieldConceptIndexingErrorCode;
  onValueSynonymsSave:  () => void;
  setEditedValueConcepts:  (valueConcepts: Dictionary<ValueConcept>) => void;
}

export const ValuesSectionEditButtons = (props: ValuesSectionEditButtonsProps) => {
  // If editing is not allowed
  if(!FeatureFlags.dataRolesEditValueSynonymsEnabled || props.isReadonly || props.dataTypes.indexOf('STRING') === -1) { return null; }
  switch(props.fieldConceptIndexingStatusCode) {
    case 'INDEXING_FAILED_RETRY_PENDING':
    case 'INDEXING_FAILED':
    case 'INDEXING_UNSUPPORTED':
      return (
        <Tooltip {...tooltipProps}>
             <img src={imgPath('pencil_14px_small.svg')} alt={Messages.edit()} style={{opacity:'0.5'}}/>
        </Tooltip>
      );
    default:
      // If we can edit, but currently are not editing
      if (!props.isEditing) {
        return (
          <ButtonWidget
            buttonType={ButtonType.Icon}
            testId="edit-values-synonyms-begin"
            handleClick={() => props.setIsEditing(true)}>
            <img src={imgPath('pencil_14px_small.svg')} alt={Messages.edit()}/>
          </ButtonWidget>);
      }
      // If we are currently editing and want the ability to cancel/save
      return (
        <>
          <ButtonWidget
            style={paddedButton}
            buttonType={ButtonType.Outline}
            testId={`edit-values-synonyms-cancel`}
            handleClick={() => props.setIsEditing(false)}>
            {Messages.cancel()}
          </ButtonWidget>
          <ButtonWidget
            style={paddedButton}
            buttonType={ButtonType.Go}
            testId={`edit-values-synonyms-save`}
            handleClick={() => {
              props.setIsEditing(false);
              props.onValueSynonymsSave();
              props.setEditedValueConcepts({});
            }}>
            {Messages.save()}
          </ButtonWidget>
        </>);
  }
};

const tooltipProps: TooltipProps = {
  getContent: () => <span><img src={imgPath('alert_14px-small.svg')} alt={Messages.dataRoleHeaderMessage_Error()}/>{Messages.dataRoleDefinitionSubspace_Values_Edit_Indexing_Error()}</span>,
  position: TooltipPosition.BottomRightCorner
};
